// extracted by mini-css-extract-plugin
export default {"controlButton":"pYYkJx","hidden":"pFKc9F","fullScreenControl":"Sxp3rL","fullScreenToggle":"cP6QNl","enterIcon":"JEodNM","exitIcon":"JQd6FG","inFullScreen":"mF3S8n"};